import { compositionTypeCodeOutcomeMeasureReport, emptyReasonNotStarted } from "../../dictionaries/CodeSystemLookup";

const addElementValuesForOutcomeMeasureReportFromComparativeEvidenceSynthesisReport = (resourceJson) => {
    if (!resourceJson) {
        return null;
    }
    let addElementValues = {
        "type": compositionTypeCodeOutcomeMeasureReport,
        "subject": [],
        "relatesTo": [
            {
                "type": {
                    "coding": [
                        {
                            "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                            "code": "part-of",
                            "display": "Part Of"
                        }
                    ]
                },
                "targetReference": {
                    "reference": "Composition/" + resourceJson.id,
                    "type": "Composition",
                    "display": resourceJson.title
                }
            }
        ],
        "section": []
    };
    if (Array.isArray(resourceJson.classification) && resourceJson.classification.length > 0) {
        let picoClassifiers = [];
        for (const item of resourceJson.classification) {
            const code = item?.type?.coding?.[0]?.code;
            if (code === "population" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "intervention" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "comparator" && item.classifier) {
                picoClassifiers.push(item);
            }
            else if (code === "outcome-measure" && item.classifier) {
                picoClassifiers.push(item);
            }
        }
        if (picoClassifiers.length > 0) {
            addElementValues.classification = picoClassifiers;
        }
    }
    let populationDescriptionReference;
    let interventionDescriptionReference;
    let comparatorDescriptionReference;
    let outcomeMeasuresReferences = [];
    let outcomeMeasuresListReferences = [];
    if (Array.isArray(resourceJson.section)) {
        for (const section of resourceJson.section) {
            let sectionCode = section?.code?.coding?.[0]?.code || section?.code?.text;
            if (sectionCode === "population" && section.entry?.[0]) {
                populationDescriptionReference = section.entry[0];
            }
            if (sectionCode === "intervention-description" && section.entry?.[0]) {
                interventionDescriptionReference = section.entry[0];
            }
            if (sectionCode === "comparator-description" && section.entry?.[0]) {
                comparatorDescriptionReference = section.entry[0];
            }
            if (sectionCode === "variables" && section.entry?.length > 0) {
                for (const entry of section.entry) {
                    if (entry.type === "EvidenceVariable") {
                        outcomeMeasuresReferences.push(entry);
                    } else if (entry.type === "List") {
                        outcomeMeasuresListReferences.push(entry);
                    }
                }
            }
        }
    }
    if (populationDescriptionReference) {
        addElementValues.subject.push(populationDescriptionReference);
    } else {
        delete addElementValues.subject;
    }
    let groupAssignmentReference;
    if (interventionDescriptionReference && comparatorDescriptionReference) {
        addElementValues.contained = [{
            "resourceType": "EvidenceVariable",
            "id": "group-assignment",
            "meta": { "profile": ["http://hl7.org/fhir/uv/ebm/StructureDefinition/group-assignment"] },
            "title": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display,
            "status": "active",
            "definition": {
                "concept": {
                    "coding": [{
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "defined-in-handling-and-category",
                        "display": "Defined in handling and category elements"
                    }]
                }
            },
            "handling": "dichotomous",
            "category": [
                {
                    "name": interventionDescriptionReference.display,
                    "valueReference": interventionDescriptionReference
                },
                {
                    "name": comparatorDescriptionReference.display,
                    "valueReference": comparatorDescriptionReference
                }
            ]
        }];
        groupAssignmentReference = {
            "reference": "#group-assignment",
            "type": "EvidenceVariable",
            "display": "GroupAssignment: " + interventionDescriptionReference.display + " vs. " + comparatorDescriptionReference.display
        }
    }
    let groupListSection = {
        "title": "Outcome Group List",
        "code": { "text": "OutcomeGroupList" },
        "text": {
            "status": "empty",
            "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
        },
        "entry": [],
        "emptyReason": emptyReasonNotStarted
    }
    if (interventionDescriptionReference) {
        groupListSection.entry.push(interventionDescriptionReference);
    }
    if (comparatorDescriptionReference) {
        groupListSection.entry.push(comparatorDescriptionReference);
    }
    if (groupAssignmentReference) {
        groupListSection.entry.push(groupAssignmentReference);
    }
    if (groupListSection.entry.length > 0) {
        delete groupListSection.emptyReason;
    }
    addElementValues.section.push(groupListSection);
    if (outcomeMeasuresReferences.length > 0) {
        for (const outcomeMeasure of outcomeMeasuresReferences) {
            if (outcomeMeasure.type === "EvidenceVariable") {
                let resultsEntry = {
                    "title": outcomeMeasure.display,
                    "code": {
                        "coding": [{
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "results", "display": "Results"
                        }]
                    },
                    "focus": outcomeMeasure,
                    "text": {
                        "status": "empty",
                        "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
                    },
                    "entry": [],
                    "emptyReason": emptyReasonNotStarted
                };
                addElementValues.section.push(resultsEntry);
            }
        }
    }
    return addElementValues;
};

export default addElementValuesForOutcomeMeasureReportFromComparativeEvidenceSynthesisReport;